/// <reference path="Utilities/_reference.ts" />

module YVR.Gallery {
	// Class names
	const classes = {
		block: 'yvr-gallery',
		button: 'yvr-gallery__button',
		hidden: 'yvr-gallery__hidden'
	};

	// Cache jQuery elements
	const elements = {
		block: $(`.${classes.block}`)
	};


	/**
	 * Initialise the modal.
	 */
	function main() {
		if (elements.block.length) {
			eventBindings();
			initGallery();
		}
	}

	/**
	 * Initialise the event bindings for the modal.
	 */
	function eventBindings() {
		setLoadMore();
	}


	/**
	 * Initialise the magnific popup gallery plugin.
	 */
	function initGallery() {
		const tLoading = elements.block.data('gallery-label-loadingimage');
		const tError = elements.block.data('gallery-label-loadingimageerror');

		elements.block.each((index, element) => {
			$(element).magnificPopup({
				callbacks: {
					close() {
						$('.yvr-wrapper').removeClass('yvr-wrapper--blur');
					},
					open() {
						$('.yvr-wrapper').addClass('yvr-wrapper--blur');

						const magnificPopup = $.magnificPopup.instance;

						$('.yvr-gallery__arrow--previous').on('click', () => {
							magnificPopup.prev();
						});

						$('.yvr-gallery__arrow--next').on('click', () => {
							magnificPopup.next();
						});
					}
				},
				delegate: '.yvr-gallery__link',
				gallery: {
					enabled: true,
					navigateByImgClick: true,
					preload: [0, 1],
					tCounter: '%curr%/%total%'
				},
				image: {
					markup: '<div class="mfp-figure">' +
						'<div class="mfp-img"></div>' +
						'<div class="mfp-bottom-bar yvr-gallery__bar">' +
						'<button class="yvr-gallery__arrow yvr-gallery__arrow--previous">Previous image</button>' +
						'<button class="yvr-gallery__arrow yvr-gallery__arrow--next">Next image</button>' +
						'<div class="mfp-close"></div>' +
						'<div class="mfp-counter"></div>' +
						'<div class="mfp-title"></div>' +
						'</div>' +
					'</div>',
					tError
				},
				mainClass: 'mfp-img-mobile',
				type: 'image',
				tLoading
			});
		});
	}


	/**
	 * When a user clicks on the load more button, show all gallery images.
	 */
	function setLoadMore() {
		elements.block.on('click', `.${classes.button}`, function (e) {
			e.preventDefault();

			const button = $(this);
			button.attr('aria-expanded', 'true');
			// Find the gallery that this button is in, in case there are multiple galleries.
			const gallery = button.closest(`.${classes.block}`);

			// Show all the hidden images by removing their hidden CSS class.
			gallery.find(`.${classes.hidden}`).removeClass(classes.hidden);

			button.remove();
		});
	}

	// Kick it
	main();

}
